import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { QueryClientProvider } from '@tanstack/react-query';
import { RouterProvider } from 'react-router';
import { Toaster } from 'sonner';
import { AuthProvider } from '@/auth/AuthProvider';
import { router } from '@/app/router';
import { createQueryClient } from '@/lib/queryClient';
import { applyTheme, getTheme } from '@/lib/theme';
import { reloadForNewVersion } from '@/lib/staleBuild';
import '@/styles/index.css';

applyTheme(getTheme());
// A page file from the previous version is gone after a deploy: load the new version instead of failing.
window.addEventListener('vite:preloadError', (e) => {
  if (reloadForNewVersion()) e.preventDefault();
});
const queryClient = createQueryClient();

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <AuthProvider>
        <RouterProvider router={router} />
      </AuthProvider>
      <Toaster position="top-right" richColors={false} closeButton visibleToasts={3} toastOptions={{ className: 'font-sans text-[13px]' }} />
    </QueryClientProvider>
  </StrictMode>,
);
